import React from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { VenueService } from '../../services';
import { EntityError } from '../../utils';
import { DefaultButton, LoadingButton } from '../buttons';
import { TextField, Checkbox } from '../fields';
import { ModalLayout } from '../layouts';

import '../../styles/modals/modal.css';
import '../../styles/modals/fiscalizationdetailsvenue.css';

class FiscalizationDetailsVenueModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      show: false,
      venue: null,
      fiscalizationEnabled: true,
      taxpayerType: 'COMPANY',
      vatRate: 10,
      companyName: '',
      addressStreet: '',
      addressNumber: '',
      addressCity: '',
      addressProvince: '',
      addressPostalCode: '',
      taxIdNumber: '',
      vatIdNumber: '',
      fisconlinePin: '',
      fisconlinePassword: '',
      fisconlineTaxId: '',
      errorMessage: null,
      invalidPost: {
        taxpayer_type: false,
        company_name: false,
        address_street: false,
        address_number: false,
        address_city: false,
        address_province: false,
        address_postal_code: false,
        tax_id_number: false,
        vat_id_number: false,
        fisconline_pin: false,
        fisconline_password: false,
        fisconline_tax_id: false,
      },
    };

    this.show = this.show.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.setFields = this.setFields.bind(this);
    this.onSaveBtnClick = this.onSaveBtnClick.bind(this);

    this.venueService = new VenueService();
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  resetFields() {
    this.setState({
      loading: false,
      show: false,
      venue: null,
      fiscalizationEnabled: true,
      taxpayerType: 'COMPANY',
      vatRate: 10,
      companyName: '',
      addressStreet: '',
      addressNumber: '',
      addressCity: '',
      addressProvince: '',
      addressPostalCode: '',
      taxIdNumber: '',
      vatIdNumber: '',
      fisconlinePin: '',
      fisconlinePassword: '',
      fisconlineTaxId: '',
      errorMessage: null,
      invalidPost: {
        taxpayer_type: false,
        company_name: false,
        address_street: false,
        address_number: false,
        address_city: false,
        address_province: false,
        address_postal_code: false,
        tax_id_number: false,
        vat_id_number: false,
        fisconline_pin: false,
        fisconline_password: false,
        fisconline_tax_id: false,
      },
    });
  }

  setFields(venue) {
    const f = venue.fiscalization;
    this.setState({
      fiscalizationEnabled: !!(f && f.system_id),
      taxpayerType: f && f.taxpayer_type ? f.taxpayer_type : 'COMPANY',
      vatRate: f && f.vat_rate != null ? f.vat_rate : 10,
      companyName: f && f.company_name ? f.company_name : '',
      addressStreet: f && f.address_street ? f.address_street : '',
      addressNumber: f && f.address_number ? f.address_number : '',
      addressCity: f && f.address_city ? f.address_city : '',
      addressProvince: f && f.address_province ? f.address_province : '',
      addressPostalCode: f && f.address_postal_code ? f.address_postal_code : '',
      taxIdNumber: f && f.tax_id_number ? f.tax_id_number : '',
      vatIdNumber: f && f.vat_id_number ? f.vat_id_number : '',
      fisconlinePin: f && f.fisconline_pin ? f.fisconline_pin : '',
      fisconlinePassword: f && f.fisconline_password ? f.fisconline_password : '',
      fisconlineTaxId: f && f.fisconline_tax_id ? f.fisconline_tax_id : '',
    });
  }

  show(set = true) {
    this.resetFields();
    this.setState({ show: set });
  }

  async onSaveBtnClick() {
    const { venueId, onComplete } = this.props;
    const {
      invalidPost,
      fiscalizationEnabled,
      taxpayerType,
      vatRate,
      companyName,
      addressStreet,
      addressNumber,
      addressCity,
      addressProvince,
      addressPostalCode,
      taxIdNumber,
      vatIdNumber,
      fisconlinePin,
      fisconlinePassword,
      fisconlineTaxId,
    } = this.state;

    this.setState({
      loading: true,
      errorMessage: null,
      invalidPost: EntityError.setInputErrors(invalidPost, null, true),
    });

    const result = await this.venueService.changeFiscalizationDetails(
      venueId,
      taxpayerType,
      companyName,
      addressStreet,
      addressNumber,
      addressCity,
      addressProvince,
      addressPostalCode,
      taxIdNumber,
      vatIdNumber,
      fisconlinePin,
      fisconlinePassword,
      fisconlineTaxId,
      vatRate,
      !fiscalizationEnabled,
    );

    if (result && result.success) {
      onComplete(true);
      this.show(false);
    } else if (result && result.ecode === 422) {
      this.setState({
        invalidPost: EntityError.setInputErrors(invalidPost, result.errors),
      });
    } else if (result && !result.success) {
      const msg = result.errors && result.errors.length > 0 ? result.errors[0] : 'An unexpected error occurred';
      this.setState({ errorMessage: msg });
    } else if (!result) {
      this.setState({ errorMessage: 'An unexpected error occurred. Please try again.' });
    }

    this.setState({ loading: false });
  }

  render() {
    const {
      show,
      loading,
      fiscalizationEnabled,
      taxpayerType,
      vatRate,
      companyName,
      addressStreet,
      addressNumber,
      addressCity,
      addressProvince,
      addressPostalCode,
      taxIdNumber,
      vatIdNumber,
      fisconlinePin,
      fisconlinePassword,
      fisconlineTaxId,
      invalidPost,
      errorMessage,
    } = this.state;
    const { t, venue } = this.props;

    return (
      show && (
        <ModalLayout title={t('Italy Fiscalization')} subtitle={venue ? venue.name : ''} width={680}>
          <Row>
            <Col md={12}>
              <p className="add-venue-subtitle">{t('Fiscalization')}</p>
              <div className="add-venue-service-list">
                <Checkbox text={t('Enable Fiscalization')} checked={fiscalizationEnabled} onChange={(checked) => this.setState({ fiscalizationEnabled: checked })} />
              </div>
            </Col>
          </Row>
          {fiscalizationEnabled && (
            <>
              <Row>
                <Col md={12}>
                  <p className="add-venue-subtitle">{t('Taxpayer')}</p>
                </Col>
                <Col md={12}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Company / Individual Name') + ' *'}
                    error={invalidPost.company_name}
                    errorText={t('Name is required')}
                    onChange={(e) => this.setState({ companyName: e.target.value })}
                    value={companyName}
                    maxLength={512}
                  />
                  {venue && venue.fiscalization && venue.fiscalization.system_id && (
                    <p className="fiscalization-name-warning">
                      {t('Changing the company name will decommission the current Fiskaly registration and create a new taxpayer, location, and system.')}
                    </p>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <p className="add-venue-subtitle" style={{ paddingTop: 10 }}>
                    {t('Taxpayer Type') + ' *'}
                  </p>
                  <div className="add-venue-service-list">
                    <Checkbox
                      text={t('COMPANY')}
                      value="COMPANY"
                      checked={taxpayerType === 'COMPANY'}
                      onChange={(checked, value) => {
                        if (checked) this.setState({ taxpayerType: value });
                      }}
                    />
                    <Checkbox
                      text={t('INDIVIDUAL')}
                      value="INDIVIDUAL"
                      checked={taxpayerType === 'INDIVIDUAL'}
                      onChange={(checked, value) => {
                        if (checked) this.setState({ taxpayerType: value });
                      }}
                    />
                  </div>
                  {invalidPost.taxpayer_type && <span className="field-error">{t('Taxpayer type is required')}</span>}
                </Col>
              </Row>

              <p className="add-venue-subtitle" style={{ paddingTop: 8 }}>
                {t('VAT Rate (IVA) *')}
              </p>
              <Row>
                <Col md={12}>
                  <div className="add-venue-service-list">
                    {[
                      { value: 22, label: '22% – Standard (Aliquota Ordinaria)' },
                      { value: 10, label: '10% – Reduced (Aliquota Ridotta)' },
                      { value: 5, label: '5% – Super-Reduced (Aliquota Super Ridotta)' },
                      { value: 4, label: '4% – Super-Reduced (Aliquota Minima)' },
                    ].map((option) => (
                      <Checkbox
                        key={option.value}
                        text={t(option.label)}
                        value={option.value}
                        checked={vatRate === option.value}
                        onChange={(checked) => {
                          if (checked) this.setState({ vatRate: option.value });
                        }}
                      />
                    ))}
                  </div>
                </Col>
              </Row>

              <p className="add-venue-subtitle" style={{ paddingTop: 8 }}>
                {t('Address')}
              </p>
              <Row>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Street') + ' *'}
                    error={invalidPost.address_street}
                    errorText={t('Street is required')}
                    onChange={(e) => this.setState({ addressStreet: e.target.value })}
                    value={addressStreet}
                    maxLength={128}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Number') + ' *'}
                    error={invalidPost.address_number}
                    errorText={t('Number is required')}
                    onChange={(e) => this.setState({ addressNumber: e.target.value })}
                    value={addressNumber}
                    maxLength={64}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Postal Code') + ' *'}
                    error={invalidPost.address_postal_code}
                    errorText={t('5-digit postal code required')}
                    onChange={(e) => this.setState({ addressPostalCode: e.target.value })}
                    value={addressPostalCode}
                    maxLength={128}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('City') + ' *'}
                    error={invalidPost.address_city}
                    errorText={t('City is required')}
                    onChange={(e) => this.setState({ addressCity: e.target.value })}
                    value={addressCity}
                    maxLength={128}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Province') + ' *'}
                    error={invalidPost.address_province}
                    errorText={t('2-letter province code required (e.g. MI)')}
                    onChange={(e) => this.setState({ addressProvince: e.target.value.toUpperCase() })}
                    value={addressProvince}
                    maxLength={2}
                  />
                </Col>
              </Row>

              <p className="add-venue-subtitle" style={{ paddingTop: 8 }}>
                {t('Italian Tax Information')}
              </p>
              <Row>
                <Col md={6}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Codice Fiscale (Tax ID)') + ' *'}
                    error={invalidPost.tax_id_number}
                    errorText={t('Codice Fiscale is required')}
                    onChange={(e) => this.setState({ taxIdNumber: e.target.value.toUpperCase() })}
                    value={taxIdNumber}
                    maxLength={128}
                  />
                </Col>
                <Col md={6}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Partita IVA (VAT Number)') + ' *'}
                    error={invalidPost.vat_id_number}
                    errorText={t('Partita IVA is required')}
                    onChange={(e) => this.setState({ vatIdNumber: e.target.value })}
                    value={vatIdNumber}
                    maxLength={128}
                  />
                </Col>
              </Row>

              <p className="add-venue-subtitle" style={{ paddingTop: 8 }}>
                {t('Fisconline Credentials (AdE)')}
              </p>
              <p className="fiscalization-credentials-note">
                {t('Fisconline passwords expire every 90 days. Keep your credentials up to date to avoid interruptions.')}{' '}
                <a href="https://support.fiskaly.com/hc/en-001/articles/17856721861020-SIGN-IT-How-to-update-the-FISCONLINE-credentials" target="_blank" rel="noopener noreferrer">
                  {t('How to update Fisconline credentials')}
                </a>
              </p>
              <Row>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Fisconline PIN') + ' *'}
                    error={invalidPost.fisconline_pin}
                    errorText={t('PIN is required')}
                    autoComplete="off"
                    onChange={(e) => this.setState({ fisconlinePin: e.target.value })}
                    value={fisconlinePin}
                    maxLength={128}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Fisconline Password') + ' *'}
                    error={invalidPost.fisconline_password}
                    errorText={t('Password is required')}
                    type="password"
                    autoComplete="new-password"
                    onChange={(e) => this.setState({ fisconlinePassword: e.target.value })}
                    value={fisconlinePassword}
                  />
                </Col>
                <Col md={4}>
                  <TextField
                    fullWidth
                    size="sm"
                    label={t('Fisconline Tax ID') + ' *'}
                    error={invalidPost.fisconline_tax_id}
                    errorText={t('Fisconline Tax ID is required')}
                    onChange={(e) => this.setState({ fisconlineTaxId: e.target.value.toUpperCase() })}
                    value={fisconlineTaxId}
                    maxLength={128}
                  />
                </Col>
              </Row>

              {errorMessage && <div className="fiskaly-error-message">{errorMessage}</div>}
            </>
          )}
          <div className="modal-buttons-container">
            <div className="modal-button">{loading || <DefaultButton text={t('CLOSE')} onClick={() => this.show(false)} fullWidth />}</div>
            <div className="modal-button">
              <LoadingButton text={t('SAVE')} state={loading ? 'LOADING' : 'DONE'} onClick={this.onSaveBtnClick} fullWidth />
            </div>
          </div>
        </ModalLayout>
      )
    );
  }
}

export default withTranslation()(FiscalizationDetailsVenueModal);
